// Copyright (c) 2016 Deere & Company

import SettlementNoRegistration from '@deere/cps-it.warranty-model-factory/lib/settlement-no-registration';
import t from 'tcomb';

const Report = t.list(SettlementNoRegistration, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/state/report.js